export default class AppConstants {
  public static readonly HOMEPAGE_EPISODE_TAKE = 4;

  public static readonly DEFAULT_REVALIDATE_IN_SECONDS = 60 * 60 * 24; // 24 hours;
}
